import React, { Component } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../component/givBee/navbar/Navbar";
// import TopMenus from "../component/givBee/topMenus/TopMenus";
class ApplicationLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div className="layout-wrapper layout-navbar-full layout-horizontal layout-without-menu">
          <div className="layout-container">
            <Navbar />
            <div
              className="layout-page"
              style={{ overflowY: "scroll", height: "0px" }}
            >
              {/* Content wrapper */}
              <div className="content-wrapper" style={{ display: "block" }}>
                {/* {this.props.pageId !== "profile" && <TopMenus />} */}
                <div className="container-xxl flex-grow-1 container-p-y">
                  <Outlet props={this.props} />
                </div>
              </div>
            </div>
            <footer
              className="content-footer footer primaryColor"
              style={{
                color: "#fff",
                bottom: 0,
                position: "sticky",
                zIndex: "1000",
                height: "30px",
                width: "-webkit-fill-available",
              }}
            >
              <div className="container-xxl d-flex flex-wrap justify-content-between py-1 flex-md-row flex-column">
                <div className="mb-1 mb-md-0">
                  <span style={{ fontSize: "12px" }}>
                    Copyright (c) 2025 GivBee, LLC. All rights reserved.
                  </span>
                </div>
                <div className="text-end" style={{ fontSize: "12px" }}>
                  <a
                    href="/terms-conditions"
                    className="footer-link me-2 ms-2"
                    target="_blank"
                    style={{ color: "#fff" }}
                  >
                    Terms &amp; Conditions
                  </a>
                  |
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    className="footer-link me-2 ms-2"
                    style={{ color: "#fff" }}
                  >
                    Privacy Policy
                  </a>
                  |
                  <a
                    href="/"
                    target="_blank"
                    className="footer-link me-2 ms-2"
                    style={{ color: "#fff" }}
                  >
                    About Us
                  </a>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </>
    );
  }
}
export default ApplicationLayout;
